module.exports = __webpack_public_path__ + "img/dis-r-5.de7aad74.png";